const getPerpendicularDistance = (p: THREE.Vector3, lineStart: THREE.Vector3, lineEnd: THREE.Vector3): number => {
    const lineDir = lineEnd.clone().sub(lineStart).normalize();
    const perpendicular = p.clone().sub(lineStart).dot(lineDir);
    const projected = lineStart.clone().add(lineDir.multiplyScalar(perpendicular));
    return p.distanceTo(projected);
};

// Ramer–Douglas–Peucker algorithm implementation
export const simplifyPointLoops = (points: THREE.Vector3[], threshold: number): THREE.Vector3[] => {
    if (points.length <= 2) {
        return points;
    }

    let maxDistance = 0;
    let maxIndex = 0;
    const lineStart = points[0];
    const lineEnd = points[points.length - 1];

    for (let i = 1; i < points.length - 1; i++) {
        const distance = getPerpendicularDistance(points[i], lineStart, lineEnd);
        if (distance > maxDistance) {
            maxDistance = distance;
            maxIndex = i;
        }
    }

    if (maxDistance > threshold) {
        const left = simplifyPointLoops(points.slice(0, maxIndex + 1), threshold);
        const right = simplifyPointLoops(points.slice(maxIndex, points.length), threshold);
        return left.slice(0, left.length - 1).concat(right);
    } else {
        return [lineStart, lineEnd];
    }
};
